module.exports = __webpack_public_path__ + "static/mobile-img-3aa369c9fcabc4a8c7d53649bcddb25c.png";